import { useEffect, useState } from "react";
import axios from "axios";
import Button from "../extra/Button";
import Input from "../extra/Input";
import { useNavigate } from "react-router-dom";
import { loginAdmin, checkMFARequired, verifyLoginTOTP, clearMFAData } from "../store/admin/admin.action";
import { connect, useSelector } from "react-redux";
import { setToast } from "../../util/toast";
import EraShop from "../../assets/images/EraShopImage.png"
import loginlogo2 from "../../assets/images/loginlogo2.png"

const Login = (props) => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [totpCode, setTotpCode] = useState("");
  const [showMFAInput, setShowMFAInput] = useState(false);
  // Proof from the server that the password step passed; the code step needs it.
  const [mfaTicket, setMfaTicket] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [error, setError] = useState({
    email: "",
    password: "",
    totp: "",
  });

  // Handle normal login or check MFA
  const handleSubmit = async () => {
    if (!email || !password) {
      let error = {};
      if (!email) error.email = "Email Is Required !";
      if (!password) error.password = "password is required !";
      return setError({ ...error });
    }

    setIsLoading(true);

    // First check if MFA is required
    const requiresMFA = await props.checkMFARequired(email);

    if (requiresMFA) {
      // First do normal login to verify password
      let login = {
        email,
        password,
      };

      // We need to verify password first, then show MFA input
      try {
        const response = await axios.post("admin/login", login);

        if (response.data.status && response.data.mfaRequired) {
          // Password is correct and two-step is on: the server sent a short-lived
          // ticket instead of a session. Ask for the code.
          setMfaTicket(response.data.mfaTicket || "");
          setShowMFAInput(true);
          setIsLoading(false);
        } else if (response.data.status && response.data.token) {
          // Two-step turned out not to apply: finish the normal sign-in.
          props.loginAdmin(login, navigate);
          setIsLoading(false);
        } else {
          // Password incorrect
          setToast("error", response.data.message);
          setIsLoading(false);
        }
      } catch (error) {
        setToast("error", error.response?.data?.message || error.message || "Login failed");
        setIsLoading(false);
      }
    } else {
      // No MFA required, do normal login
      let login = {
        email,
        password,
      };
      props.loginAdmin(login, navigate);
      setIsLoading(false);
    }
  };

  // Handle TOTP verification
  const handleTOTPSubmit = () => {
    if (!totpCode || totpCode.length !== 6) {
      return setError({ ...error, totp: "Please enter a 6-digit code" });
    }

    setIsLoading(true);
    props.verifyLoginTOTP(email, totpCode, navigate, mfaTicket);
    setIsLoading(false);
  };

  // Go back to login form
  const handleBackToLogin = () => {
    setShowMFAInput(false);
    setTotpCode("");
    setError({ ...error, totp: "" });
    props.clearMFAData();
  };

  return (
    <>
      <div className="mainLoginPage">
        <div className="loginDiv">
          <div className="row">
            <div
              className="col-xl-6 d-xxl-block d-xl-block d-none boxCenter p-5"
            style={{ background: "#F0C420" }}
            >
                <img
                  className="img-fluid"
                  src={EraShop}
                  alt="text logo"
                  srcset=""
                />
                <img className="img-fluid"
                src={loginlogo2}
                alt="login logo" />
            </div>
            <div className="col-xl-6 col-md-12 boxCenter"
              style={{
                background: "#FEFEFE"
              }}
            >
              <div className="loginDiv2">
                <div className="loginPage pt-3">
                  <div className="my-4">
                    <div className="loginLogo me-3 pt-1 pe-1">
                      <img
                        src={require("../../assets/images/Eralogo22.png")}
                        alt=""
                        width={"80px"}
                      />
                    </div>
                  </div>

                  {!showMFAInput ? (
                    // Normal Login Form
                    <>
                      <div
                        style={{
                          color: "#000",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "22px",
                          letterSpacing: "0.48px",
                        }}
                        className=""
                      >
                        <p>Welcome back !!!</p>
                      </div>
                      <div className=" mb-3">
                        <h3
                          className="fw-bold text-dark"
                          style={{ fontSize: "56px", fontWeight: "600" }}
                        >
                          Log In
                        </h3>
                      </div>
                      <div className="loginInput">
                        <Input
                          label={`Email`}
                          id={`loginEmail`}
                          type={`email`}
                          value={email}
                          style={{ background: "rgba(240, 196, 32, 0.11)" }}
                          errorMessage={error.email && error.email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                            if (!e.target.value) {
                              return setError({
                                ...error,
                                email: `Email Is Required`,
                              });
                            } else {
                              return setError({
                                ...error,
                                email: "",
                              });
                            }
                          }}
                        />

                        <Input
                          label={`Password`}
                          id={`loginPassword`}
                          type={`password`}
                          value={password}
                          errorMessage={error.password && error.password}
                          onChange={(e) => {
                            setPassword(e.target.value);
                            if (!e.target.value) {
                              return setError({
                                ...error,
                                password: `Password Is Required`,
                              });
                            } else {
                              return setError({
                                ...error,
                                password: "",
                              });
                            }
                          }}
                        />
                      </div>

                      <div className="loginButton mt-5">

                        <Button
                          newClass={`blackFont ms-3`}
                          btnColor={`btnBlackPrime`}
                          style={{

                            borderRadius: "20px",
                            width: "170px",
                            height: "46px",
                            color:"#fff"
                          }}
                          btnName={isLoading ? `Loading...` : `Log In`}
                          onClick={handleSubmit}
                          disabled={isLoading}
                        />
                      </div>
                    </>
                  ) : (
                    // MFA Verification Form
                    <>
                      <div
                        style={{
                          color: "#000",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "22px",
                          letterSpacing: "0.48px",
                        }}
                        className=""
                      >
                        <p>Two-Factor Authentication</p>
                      </div>
                      <div className=" mb-3">
                        <h3
                          className="fw-bold text-dark"
                          style={{ fontSize: "40px", fontWeight: "600" }}
                        >
                          Enter Code
                        </h3>
                      </div>
                      <div className="mb-3" style={{ color: "#666", fontSize: "14px" }}>
                        <p>Open your authenticator app (Google Authenticator, Authy, etc.) and enter the 6-digit code.</p>
                      </div>
                      <div className="loginInput">
                        <Input
                          label={`6-Digit Code`}
                          id={`totpCode`}
                          type={`text`}
                          value={totpCode}
                          maxLength={6}
                          style={{
                            background: "rgba(240, 196, 32, 0.11)",
                            fontSize: "24px",
                            textAlign: "center",
                            letterSpacing: "8px"
                          }}
                          errorMessage={error.totp && error.totp}
                          onChange={(e) => {
                            const value = e.target.value.replace(/[^0-9]/g, '');
                            setTotpCode(value);
                            if (!value) {
                              return setError({
                                ...error,
                                totp: `Code is required`,
                              });
                            } else if (value.length !== 6) {
                              return setError({
                                ...error,
                                totp: `Enter 6 digits`,
                              });
                            } else {
                              return setError({
                                ...error,
                                totp: "",
                              });
                            }
                          }}
                        />
                      </div>

                      <div className="loginButton mt-4 d-flex gap-2">
                        <Button
                          newClass={`ms-3`}
                          btnColor={`btn-outline-secondary`}
                          style={{
                            borderRadius: "20px",
                            width: "120px",
                            height: "46px",
                          }}
                          btnName={`Back`}
                          onClick={handleBackToLogin}
                        />
                        <Button
                          newClass={`blackFont`}
                          btnColor={`btnBlackPrime`}
                          style={{
                            borderRadius: "20px",
                            width: "170px",
                            height: "46px",
                            color:"#fff"
                          }}
                          btnName={isLoading ? `Verifying...` : `Verify`}
                          onClick={handleTOTPSubmit}
                          disabled={isLoading}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(null, { loginAdmin, checkMFARequired, verifyLoginTOTP, clearMFAData })(Login);

{
  /*  */
}
